<template>
  <div>
    <h2>Reset Password</h2>
    <div v-if="!token">
      <p>You must provide a valid token to reset your password</p>
    </div>
    <div v-if="message">
      <p>{{message}}</p>
    </div>
    <div v-if="token && canSubmit">
      <div class="row">
        <div class="six columns">
          <label for="reset-password">New Password</label>
          <input
            class="u-full-width"
            id="reset-password"
            type="password"
            placeholder="password"
            v-model="password"
            @keyup.13="submit"
          >
        </div>
        <div class="twelve columns">
          <input
            class="button"
            value="Set Password"
            @click="submit"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  params: ['token'],
  data () {
    return {
      loadState: 'empty',
      password: '',
      token: this.$route.query.token,
      message: '',
      canSubmit: true
    }
  },
  methods: {
    submit () {
      this.loadState = 'loading'
      this.$http.post(process.env.API_URL + '/resetpassword.php', {
        password: this.password,
        token: this.token
      }).then(res => {
        if (res.body.status === 'success') {
          this.loadState = 'success'
          this.canSubmit = false
          this.message = res.body.data
        } else {
          this.loadState = 'error'
          this.message = res.body.data
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ResetPassword.vue?27c1dd7f